import React from 'react';
import Image from "../elements/Image";
import BannerImage01 from '../../assets/images/image-banner-01.webp';
import BannerImage02 from '../../assets/images/image-banner-02.webp';
import Button from "../forms/Button";
import { classNames } from "../../helpers/classNames";

const BannerElements = () => {
  return (
    <>
      <div className="bg-white absolute bottom-0 right-0 w-[calc(100vw*4)] h-[calc(100vh*4)] rounded-full" />
      <div className="bg-doodle-pattern absolute bottom-0 left-0 w-full h-full" />
      <div className="absolute bottom-0 left-0">
        <div className="animate-float">
          <div className="bg-gradient-to-tr from-indigo to-purple absolute bottom-48 -left-10 w-24 aspect-square rounded-full" />
        </div>
        <div className="animate-float-reverse">
          <div className="bg-gradient-to-tr from-red to-orange absolute bottom-28 left-8 w-16 aspect-square rounded-full" />
        </div>
        <div className="animate-float">
          <div className="bg-gradient-to-tr from-green to-yellow absolute bottom-10 -left-5 w-12 aspect-square rounded-full" />
        </div>
      </div>
    </>
  );
};

const HomeBanner = () => {
  const features = [
    { _id: 1, name: "Hand-crafted", icon: "fa-regular fa-pen-ruler", classes:"text-purple"},
    { _id: 2, name: "Custom Styles", icon: "fa-regular fa-palette", classes:"text-orange"},
    { _id: 3, name: "Kid-Friendly", icon: "fa-regular fa-house-chimney-heart", classes:"text-green"},
  ]
  return (
    <>
      <section className="relative min-h-screen py-20 flex items-center bg-gradient-to-tr from-red/80 via-blue/80 to-green/80 overflow-hidden">
        <BannerElements/>
        <div className="relative w-full px-4 sm:px-0 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl 3xl:max-w-9xl mx-auto">
          <div className="grid grid-cols-2 gap-10">
            <div className="relative space-y-6">
              <h1 className="text-7xl text-black font-BubblegumSans font-semibold">
                Turn{" "}
                <span className="text-blue inline-block animate-text-float-1">Photos</span>{" "}
                into{" "}
                <span className="text-red inline-block animate-text-float-3">Magic</span>{" "}
                <span className="text-green inline-block animate-text-float-2">Coloring Books</span>
              </h1>
              <div className="text-2xl text-gray-600">Transform your cherished family photos into personalized coloring adventures that kids will love! Create unique, custom coloring books from your favorite memories.</div>
              <div className="!mt-16">
                <Button buttonLabel={"Get Started"} buttonClasses={"bg-gradient-to-tr from-red to-yellow h-14 !px-12 hover:scale-105"} buttonLabelClasses={"text-lg"}/>
              </div>
              {features?.length > 0 && (
                <div className="flex items-center gap-4">
                  {features?.map((item, index) => (
                    <div key={index} className="text-lg"><i className={classNames("text-xl", item?.icon, item?.classes)}></i> {item?.name}</div>
                  ))}
                </div>
              )}
            </div>
            <div className="relative">
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center gap-10">
                <div className="animate-float">
                  <div className="w-72 aspect-[3/4] flex flex-shrink-0 bg-white rounded-xl shadow-xl border-8 border-white overflow-hidden -translate-y-1/4">
                    <Image src={BannerImage01} alt={''} width={'100%'} height={'100%'} effect={'blur'} classes={'object-cover'} />
                  </div>
                </div>
                <div className="animate-pulse">
                  <div className="absolute w-28 aspect-auto bottom-0 left-1/2 -translate-x-[150%] translate-y-1/2 -rotate-45">
                    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 375.76 633.8"><path fill="#fff" d="M174,460.55c28.33,68.82,69.2,124.32,140.44,147.6-6.64-7.52-15-16.63-22.84-26.14-1.57-1.91-1.27-5.36-1.84-8.1,3.08-.25,6.65-1.59,9.13-.49,3.56,1.58,6.77,4.56,9.35,7.61,12.56,14.85,28.19,26,44.14,36.67,2.35,1.58,5.29,2.3,8,3.34,6,2.32,11.21,5.59,15.38,12.51-2.58-.2-3.93-.29-5.26-.42-24.16-2.45-48.31-3.24-72.51-.37a149.38,149.38,0,0,1-16.24,1c-3.46,0-7.32-.28-8.28-4.72-1-4.66,1.57-7.72,5.67-8.8,8-2.09,16.09-3.59,23.6-5.21-11.88-4.51-24.57-8.66-36.68-14.09-25-11.2-44.12-29.89-61.6-50.41A291.57,291.57,0,0,1,154.87,467c-2.12-5.41-4.55-8-10.66-9.17C95.58,448.22,58.3,421.75,31.91,380c-6.25-9.89-11.25-20.58-16.78-30.82l25.15-9.78c19.81,46.57,52.77,78.3,102.8,92.67-1.11-6.14-2.19-11.35-3-16.61-6.94-45.35-.82-88.51,22.59-128.45,10.5-17.91,24.81-31.8,45.66-37.2,21.88-5.66,40.75,1.3,56.9,15.62,30.82,27.35,41.29,76.13,23.82,114.19-21.62,47.09-57.64,75.35-110.33,80.18C177.58,459.92,176.45,460.17,174,460.55Zm-15-71.16c1.22,8.85,3.39,24.16,5.41,39.5.66,5.09,3,6.92,8.37,6.85,44.32-.57,77.46-20.72,100.74-57.62,22.23-35.24,9.65-78.36-14.71-99-11.33-9.59-24.17-15.36-39.48-13.06-14.82,2.25-25.36,11.1-33.48,23C166.56,317.31,160,349.22,159,389.39Z" /><path fill="#fff" d="M27.86,292.24c.89,7.34,8.33,37.58,12.42,47.17,6,14-20.46,8-25.15,9.78-11.91-29.76-12.08-45.38-13-48.39C1.41,292.75.17,284.53,0,276.29Q-1.62,169.88,64.62,86.46c25-31.34,54.85-57,91-74.76,14.09-6.95,28.71-12.77,45-11.53a4.83,4.83,0,0,1,1.73.14c2,1.06,4,2.23,6,3.36-1.54,1.69-2.78,4-4.69,4.95-3.95,2-8.28,3.19-12.44,4.75C159.84,25.14,134,45.07,110.87,68.65,53.58,127,24.62,196.88,26.79,279.09,26.91,283.34,27.47,287.58,27.86,292.24Z" /></svg>
                  </div>
                </div>
                <div className="animate-float-reverse">
                <div className="w-72 aspect-[3/4] flex flex-shrink-0 bg-white rounded-xl shadow-xl border-8 border-white overflow-hidden translate-y-1/4">
                  <Image src={BannerImage02} alt={''} width={'100%'} height={'100%'} effect={'blur'} classes={'object-cover'} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeBanner;